"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = require("styled-components");

var React = require("react");

var palette_1 = require("../../constants/palette");

var VerticalRule = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  border-left: 1px solid ", ";\n  display: inline-block;\n  height: 48px;\n  margin-left: 15px;\n  margin-right: 15px;\n"], ["\n  border-left: 1px solid ", ";\n  display: inline-block;\n  height: 48px;\n  margin-left: 15px;\n  margin-right: 15px;\n"])), palette_1.default.lightGrey);
var WrappingLabel = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  word-wrap: break-spaces;\n  width: 150px;\n  color: ", ";\n  font-weight: 600;\n  font-size: 13px;\n"], ["\n  word-wrap: break-spaces;\n  width: 150px;\n  color: ", ";\n  font-weight: 600;\n  font-size: 13px;\n"])), palette_1.default.medGrey);
var ClubLogo = styled_components_1.default.img(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  max-width: 135px;\n  max-height: 40px;\n"], ["\n  max-width: 135px;\n  max-height: 40px;\n"])));
var NavClubInfoDOM = styled_components_1.default.section(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  width: 550px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: nowrap;\n  justify-content: flex-start;\n  align-items: center;\n  width: 550px;\n"])));

var NavClubInfo = function NavClubInfo(props) {
  return React.createElement(NavClubInfoDOM, null, React.createElement("a", {
    href: props.logoLink,
    tabIndex: 0
  }, React.createElement(ClubLogo, {
    src: props.logo,
    alt: "Logo: " + props.clubName
  })), React.createElement(VerticalRule, null), React.createElement(WrappingLabel, null, props.locationName));
};

exports.default = NavClubInfo;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;